import { DateTime } from 'luxon'
import { statusDefaultIcon, statusDefaultTextColor } from '../prelievo.config';

export const PRELIEVO_STATUS = ['ok', 'warning', 'alert'] as const;
export type TPrelievoStatus = typeof PRELIEVO_STATUS[number];

export interface IPrelievo{
  id?: number,
  idControlli: [],
  codicePrelievo: string,
  dataPrelievo: Date,
  oraPrelievo: string,
  prelievoOperatoDa: string,
  codiceAnalisi: string,
  dataAnalisi: Date,
  oraAnalisi: string,
  analisiOperateDa: string,
  tipoControllo?: string,
  poiId: number,
  codicePoi: string,
  processoId?: number,
  status: TPrelievoStatus,//'ALERT' | 'WARNING' | 'OK',
  createdBy?: string,
  createdDate?: DateTime,
  uuid:string,
  dataOraPrelievo:string
}

export function getStatusIcon(status: TPrelievoStatus): string {
  let icon = statusDefaultIcon[status];
  let textColor = statusDefaultTextColor[status];
  if(icon){
    return `<mat-icon matTooltip="${status}" class="mat-mdc-tooltip-trigger ${textColor} material-symbols-outlined">${icon}</mat-icon>`;
  }else{
    return ''
  }

}


